import { DASH, fmtPercent } from "../format";
import { C, tabular } from "../theme";

/** pct is 0–100 (may exceed 100 when over-limit); ≥ 75% is shown in amber. */
export const UsageBar = ({ pct }: { pct: number | null }) => {
  if (pct === null) return <>{DASH}</>;
  const tone = pct >= 75 ? C.warn : C.ok;
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <div
        aria-hidden="true"
        style={{
          width: 80,
          height: 6,
          borderRadius: 3,
          background: C.track,
          flex: "none",
        }}
      >
        <div
          style={{
            height: 6,
            borderRadius: 3,
            width: `${Math.min(100, pct)}%`,
            background: tone,
          }}
        />
      </div>
      <span style={tabular}>{fmtPercent(pct)}</span>
    </div>
  );
};
